import { oc } from '@orpc/contract';
import { dashboardStatsSchema } from '../schemas/benchmarks.schemas.js';
export const getDashboardStatsContract = oc
    .route({
    method: 'GET',
    path: '/benchmarks/dashboard-stats',
    tags: ['Benchmarks'],
    summary: 'Catalogue and run counters for the dashboard',
})
    .output(dashboardStatsSchema);
//# sourceMappingURL=get-dashboard-stats.contract.js.map